import MainButton from "../../../components/button/mainButton";
import HeaderBar from "../../../components/header/headerBar";
import EmptyModel from "../../../components/modal/emptyModal";
import Icon from "@mdi/react";
import { mdiPencilCircle, mdiDelete } from "@mdi/js";
import { Table, TableColumn } from "../../../components/table";
import { useEffect, useState } from "react";
import { Input } from "../../../components/textfield";
import { useParams } from "react-router-dom";

const BranchesMedical = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [toolName, setToolName] = useState<string>("");
  const [toolAmount, setToolAmount] = useState<string>("");
  const [toolId, setToolId] = useState<string>("");
  const [state, setState] = useState<any>({
    tools: [],
  });

  function onClose() {
    setIsOpen(false);
  }

  const column = [
    {
      title: "",
    },
    {
      title: "ประเภทเครื่องมือ",
    },
    {
      title: "จำนวนห้อง",
      align: "center",
    },
    {
      title: "Action",
      align: "center",
      colspan: 2,
    },
  ];

  const data = [
    {
      _id: 1,
      toolName: "เครื่อง HELIOS II",
      toolAmount: 5,
    },
    {
      _id: 2,
      toolName: "เครื่อง Hifu",
      toolAmount: 5,
    },
    {
      _id: 3,
      toolName: "เครื่อง MeDioStar",
      toolAmount: 3,
    },
    {
      _id: 4,
      toolName: "เครื่อง Coolsculpting",
      toolAmount: 3,
    },
    {
      _id: 5,
      toolName: "เครื่อง Ulthera",
      toolAmount: 5,
    },
  ];

  const getData = () => {};

  const getDataOne = (value: any) => {
    setToolId(value._id);
    setToolName(value.toolName);
    setToolAmount(value.toolAmount);
  };

  const createData = () => {
    console.log("CREATE DATA !");
    // axios
    //   .post(`/agencies`, {
    //     code: code,
    //     name: name,
    //     agencyType: agencyType,
    //     address: address,
    //     phoneNumber: phoneNumber,
    //   })
    //   .then((res) => {
    //     setTimeout(() => getData(), 200);
    //     setIsOpen(false);
    //   });
    setIsOpen(false);
    return onHandledata({
      toolName: toolName,
      toolAmount: toolAmount,
    });
  };

  const updateData = (id: any) => {
    console.log("UPDAET DATA => ", id);
    // axios
    //   .patch(`/agencies/${id}`, {
    //     code: code,
    //     name: name,
    //     agencyType: agencyType,
    //     address: address,
    //     phoneNumber: phoneNumber,
    //   })
    //   .then((res) => {
    //     setTimeout(() => getData(), 200);
    //     setIsOpen(false);
    //   });
  };

  const setCreat = () => {
    setToolName("");
    setToolAmount("");
  };

  function onHandledata(data: any) {
    const tools = state.tools;
    tools.push(data);

    setState({ ...state, tools });
  }

  useEffect(() => {
    getData();
  }, []);

  return (
    <>
      <HeaderBar title="BRANCHES / MEDICAL EQUIPMENT" btnBack={true} />
      <div style={{ padding: "10px 40px" }}>
        <EmptyModel show={isOpen} onClose={onClose} width="50%">
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              padding: "20px 40px",
            }}
          >
            <h4>สร้างเครื่องมือ</h4>

            <div className="row justify-center  mt-20">
              <Input
                className="col-8"
                title="ชื่อเครื่องมือ"
                value={toolName}
                onChange={(e) => {
                  setToolName(e.target.value);
                }}
              />
            </div>
            <div className="row justify-center mt-20">
              <Input
                className="col-8"
                title="จำนวนเครื่องมือ"
                value={toolAmount}
                onChange={(e) => {
                  setToolAmount(e.target.value);
                }}
              />
            </div>
            <div className="justify-center mt-20">
              <MainButton
                className="mg-10"
                background="#E76464"
                title="ยกเลิก"
                onClick={() => {
                  setIsOpen(false);
                }}
              />
              <MainButton
                className="mg-10"
                title="บันทึกข้อมูล"
                onClick={() => {
                  toolId ? updateData(toolId) : createData();
                }}
              />
            </div>
          </div>
        </EmptyModel>
        <div
          style={{ display: "flex", justifyContent: "end", marginTop: "20px" }}
        >
          <MainButton
            title="สร้างเครื่องมือ"
            onClick={() => {
              setCreat();
              setIsOpen(true);
            }}
          />
          {/* <div className="btn-new">สร้าง OPD ใหม่</div> */}
        </div>
        <div className="mt-20">
          <Table header={column}>
            {state.tools.map((item: any, index: number) => (
              <tr
                key={index}
                // onClick={() => history.push(`/usedcourse/${item.SO}`)}
                style={{ cursor: "pointer" }}
              >
                <TableColumn width="3%" align="center">
                  {index + 1}
                </TableColumn>
                <TableColumn width="15%">{item.toolName}</TableColumn>
                <TableColumn width="5%" align="center">
                  {item.toolAmount}
                </TableColumn>
                <TableColumn width="3%" align="center">
                  <div
                    onClick={() => {
                      getDataOne(item);
                      setIsOpen(true);
                    }}
                  >
                    <Icon path={mdiPencilCircle} size="20" color="#5BAEA9" />
                  </div>
                </TableColumn>
                <TableColumn width="3%" align="center">
                  <Icon path={mdiDelete} size="20" color="#E76464" />
                </TableColumn>
              </tr>
            ))}
          </Table>
        </div>
      </div>
    </>
  );
};
export default BranchesMedical;
